import { render, staticRenderFns } from "./OverviewComponent.vue?vue&type=template&id=08fc4853&scoped=true&"
import script from "./OverviewComponent.vue?vue&type=script&lang=js&"
export * from "./OverviewComponent.vue?vue&type=script&lang=js&"
import style0 from "./OverviewComponent.vue?vue&type=style&index=0&id=08fc4853&lang=scss&scoped=true&"
import style1 from "./OverviewComponent.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08fc4853",
  null
  
)

export default component.exports